// src/contexts/LanguageContext.js
import { createContext, useState, useContext, useEffect } from 'react';
import { translations } from './translations';

const LanguageContext = createContext({
    language: 'en',
    setLanguage: () => {},
    t: translations['en']
});

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState('en');
    const [t, setT] = useState(translations[language]);

    useEffect(() => {
        // Récupérer la langue depuis localStorage si elle existe
        const savedLanguage = localStorage.getItem('language') || 'en';
        setLanguage(savedLanguage);
        setT(translations[savedLanguage]);
    }, []);

    const changeLanguage = (lang) => {
        setLanguage(lang);
        setT(translations[lang]);
        localStorage.setItem('language', lang);
    };

    return (
        <LanguageContext.Provider value={{ language, setLanguage: changeLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    return useContext(LanguageContext);
};